import { KEYCODE } from '@/constants';

class WPNavItem extends HTMLElement {
  constructor(self) {
    self = super(self);
    this._controls = this.nextElementSibling;
    return self;
  }

  static get is() {
    return 'wp-nav-item';
  }

  static get observedAttributes() {
    return ['expanded'];
  }

  get expanded() {
    return this.hasAttribute('expanded');
  }

  set expanded(value) {
    if (Boolean(value)) {
      this.setAttribute('expanded', '');
    } else {
      this.removeAttribute('expanded');
    }
  }

  connectedCallback() {
    this.setAttribute('aria-haspopup', 'true');
    this.setAttribute('role', 'button');
    this.tabIndex = 0;

    // Set expanded
    this._expandedChanged();

    this.addEventListener('click', this._handleClick, false);
    this.addEventListener('keydown', this._handleKeyDown, false);
  }

  /**
   * Lifecycle event when watched attribute is changed
   *
   * @param {string} name Attribute name
   * @param {any} oldVal Old value of attribute
   * @param {any} newVal New value of attribute
   */
  attributeChangedCallback(name, oldVal, newVal) {
    switch (name) {
      case 'expanded':
        this._expandedChanged();
    }
  }

  _handleClick() {
    if (this.expanded) {
      this.expanded = false;
    } else {
      this.expanded = true;
    }
  }

  _expandedChanged() {
    if (this.expanded) {
      this._controls.hidden = false;
      this.setAttribute('aria-expanded', 'true');
      this.$emit('menuitemchanged', this);
    } else {
      this._controls.hidden = true;
      this.setAttribute('aria-expanded', 'false');
      this.$emit('menuitemchanged', this);
    }
  }

  _handleKeyDown(evt) {
    const keyCode = evt.which;

    if (keyCode === KEYCODE.SPACE || keyCode === KEYCODE.ENTER) {
      evt.preventDefault();
      evt.stopPropagation();

      this.click();
    }
  }
}

customElements.define(WPNavItem.is, WPNavItem);
